var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboardShift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M873.28 589.25H697.8v165.16A82.58 82.58 0 01615.23 837H408.78a82.59 82.59 0 01-82.58-82.59V589.25H150.72c-17.11 0-31-11-31-28.07 0-9.16 18.92-23.75 31-33.86l324.94-319.68S493.4 187 511.35 187c18.39 0 37 20.64 37 20.64l324.93 319.68c12.05 10.11 31 24.7 31 33.86-.03 17.1-13.89 28.07-31 28.07z",
    fillRule: "evenodd"
  })));
}
export default SvgKeyboardShift;